import { AggregateScoresNode } from "~/pages/reports/SecurityReport/utils/securityReportTypes";

export function isAggregateScore(
  finding: { __typename?: string } | null | undefined,
): finding is AggregateScoresNode {
  return finding?.__typename === "AggregateScore";
}
